import { useState } from "react";
import "../components/customer-panel/customer-panel.scss";
import pic from "../assets/images/profile.png";
import { CgProfile } from "react-icons/cg";
import { BsCardChecklist } from "react-icons/bs";
import CustomerOrders from "components/customer-panel/CustomerOrders";

import { useParams } from "react-router-dom";
function CustomerPanel() {
  const [v, setV] = useState("fd");
  const [tabStatus, setTabStatus] = useState({ orders: true, profile: false });

  // let param = useParams();
  // console.log("***");
  return (
    <div
      className="customer-panel d-flex py-4 justify-content-evenly "
      style={{ backgroundColor: "lightgray" }}
    >
      <div
        className="shadow round d-flex flex-column  bg-lightgray"
        style={{ height: "300px", width: "20%" }}
      >
        <img className="logo-size align-self-center" src={pic}></img>
        <div className="ms-5 my-2">
          <CgProfile className="icon-size" />
          <span className="ms-2">پروفایل</span>
        </div>
        <div
          className="ms-5 my-2"
          onClick={() => {
            setTabStatus((prev) => {
              return { ...prev, orders: true };
            });
          }}
        >
          <BsCardChecklist className="icon-size" />
          <span className="ms-2">سفارشات</span>
        </div>
      </div>
      <div
        className="shadow round bg-lightgray"
        style={{ height: "300px", width: "70%" }}
      >
        {tabStatus.orders && <CustomerOrders />}
      </div>
    </div>
  );
}
export default CustomerPanel;
